<template>
  <v-card>
    <v-toolbar dense>
      <v-tooltip top>
        <v-btn flat icon @click="$router.go(-1)" slot="activator">
          <v-icon>far fa-arrow-left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title class="text-capitalize">
        {{title}}
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip top v-if="id !== 'new' && !copy">
        <v-btn flat icon to="?copy" slot="activator">
          <v-icon>far fa-copy</v-icon>
        </v-btn>
        <span>Copy</span>
      </v-tooltip>
      <v-tooltip top v-if="id !== 'new' && !copy">
        <v-btn flat icon slot="activator" @click.stop="del = true">
          <v-icon>far fa-trash</v-icon>
        </v-btn>
        <span>Delete</span>
      </v-tooltip>
    </v-toolbar>
    <v-dialog :value="del" v-if="id !== 'new' && !copy" width="300">
      <v-card>
        <v-card-title class="headline">
          Delete {{current && current.name}}?
          <br>
          Are you sure?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click.stop="del = false">Cancel</v-btn>
          <v-btn flat color="error" @click.stop="delCurrent">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-text>
      <admin-form :service="service" :current="current"/>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import adminForm from './form.vue';

export default {
  components: {
    adminForm,
  },
  props: {
    service: {
      type: String,
      default: 'users',
    },
  },
  data() {
    return {
      del: false,
      models: {
        flags: this.$FeathersVuex.Flag,
        locations: this.$FeathersVuex.Location,
        procedures: this.$FeathersVuex.Procedure,
        steps: this.$FeathersVuex.Step,
        units: this.$FeathersVuex.Unit,
        users: this.$FeathersVuex.User,
      },
    };
  },
  computed: {
    ...mapGetters('flags', { flagsGet: 'get' }),
    ...mapGetters('locations', { locationsGet: 'get' }),
    ...mapGetters('procedures', { proceduresGet: 'get' }),
    ...mapGetters('steps', { stepsGet: 'get' }),
    ...mapGetters('units', { unitsGet: 'get' }),
    ...mapGetters('users', { usersGet: 'get' }),
    id() { return this.$route.params.id; },
    current() {
      let current = null;
      if (this.id === 'new') return new this.models[this.service]();
      current = this[`${this.service}Get`](this.id);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (!current) return this.$router.push(`/admin/${this.service}`);
      if (typeof current.save === 'undefined') current = new this.models[this.service](current);
      current = current.clone();
      if (this.copy) delete current._id;
      return current;
    },
    copy() { return typeof this.$route.query.copy !== 'undefined'; },
    title() {
      const name = this.copy
        ? `Copy ${this.current && this.current.name}`
        : this.current && this.current.name;
      return this.id === 'new'
        ? `New ${this.service.replace(/s$/, '')}`
        : name;
    },
  },
  mounted() {
    this.checkId();
  },
  updated() {
    this.checkId();
  },
  methods: {
    checkId() {
      if (this.id !== 'new' && !this[`${this.service}Get`](this.id)) {
        this.$router.push(`/admin/${this.service}`);
      }
    },
    async delCurrent() {
      await this.current.remove();
      this.del = false;
      this.$router.push(`/admin/${this.service}`);
    },
  },
};
</script>
